<template>
  <div class="row">
    <!--General Top Bar -->
    <!-- <general-top-bar :title="$t('pages.groupOptions')"></general-top-bar> -->
    <!--End General Top Bar -->
    <div class="row">
      <div class="col-md-12">
        <div class="card mar-15">
          <div class="card-content">
            <div class="col-sm-12">
              <div class="pull-right" style="position:relative;z-index:2">
                <router-link class="btn btn-info btn-icon add mar-bt-20" title="" :to="{ path: 'group-option/add'}">
                  <img src="/static/img/icons/add.png">
                  {{ $t('general.add') }}
                </router-link>
              </div>
            </div>
            <table class="table width-table" ref="sortableTable">
              <thead>
                <tr>
                  <!-- <th></th> -->
                  <th width="20%">{{$t('companyOptions.id')}}</th>
                  <th width="50%">{{$t('companyOptions.name')}}</th>
                  <th width="10%"></th>
                </tr>
              </thead>
              <draggable v-model="optionData" :sort="false" :element="'tbody'" @end="adjustSort">
                <template v-for="(item, index) in optionData">
                  <tr class="sortableRow" :key="item.id">
                    <td>{{ item.id }}</td>
                    <td>{{ item.name }}</td>
                    <td>
                      <div class="edit" @click="goToRecord(item,[],[], $event)">
                        <i class="fa fa-pencil"></i>{{$t('general.edit')}}
                      </div>
                    </td>
                  </tr>
                </template>
              </draggable>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="space_for_alert_box" style="height: 100px; width: 100%;"></div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Table, TableColumn, Option} from 'element-ui'
  import DataTables from 'vue-data-tables'
  import draggable from 'vuedraggable'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Input)
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Option)
  Vue.use(DataTables)
  export default {
    components: {
      PPagination,
      // GeneralTopBar,
      PSwitch,
      [Input.name]: Input,
      draggable
    },
    props: {
      callback: {
        required: false
      },
      callbackAdd: {
        required: false
      },
      isTable: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      this.token = this.$session.get('token')
      this.getData()
    },
    mounted () {
      this.$bus.$on('refresh', this.onRefresh)
    },
    beforeDestroy () {
      this.$bus.$off('refresh')
    },
    data () {
      return {
        loading: true,
        loading2: true,
        token: null,
        apiUrl: null,
        optionData: []
      }
    },
    methods: {
      goToRecord (row, event, column) {
        this.globalGoToRecord(row, event, column, '/group-option/edit/')
      },
      onRefresh () {
        this.getData()
      },
      getData () {
        var data = {
          token: this.token,
          company_id: this.$session.get('selectedCompany')
        }
        this.apiRequest('/group-options', 'GET', data, (response) => {
          if (response.status === true) {
            this.optionData = response.data

            this.$nextTick(() => {
              this.loading = false
            })
          }
        })
      },
      adjustSort () {
        // TO DO
      }
    }
  }
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/GroupOptions/GroupOptions.vue